/** iPhone, iPad, iPod — includes iPadOS with desktop UA. */
export function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

export function geolocationPermissionDeniedMessage(): string {
  if (isIosDevice()) {
    return (
      'Accès refusé. Autorisez la localisation via le bouton ci-dessus, ' +
      'ou dans Réglages → Apps → Safari → Localisation.'
    );
  }

  return (
    'Accès refusé. Autorisez la localisation dans votre navigateur, puis réessayez.'
  );
}

export function geolocationIdleHint(): string {
  return 'Appuyez sur le bouton ci-dessous pour autoriser la localisation.';
}

/** In-app browsers (Facebook, Instagram…) often block camera and GPS. */
export function isInAppBrowser(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /FBAN|FBAV|Instagram|Line\//i.test(navigator.userAgent);
}

export function inAppBrowserWarning(): string {
  return (
    'Ouvrez ce lien dans Chrome ou Safari (pas depuis Facebook ou Instagram) ' +
    'pour utiliser la carte et l’appareil photo.'
  );
}
